import $ from 'jquery';
import jQuery from 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class TopFunctions {
  constructor() {
    const $cover = $('#js-cover')
    const $coverZoom = $('#js-coverZoom')
    const $floorplan = $('.js-floorplan')


    // ドラッグ操作(タッチ端末は除く)
    if (window.ontouchstart === undefined) {
      $cover.mousedown(function (event) {
          event.preventDefault();
          $cover.data({
            'down': true,
            'move': false,
            'x': event.clientX,
            'y': event.clientY,
            'scrollleft': $cover.scrollLeft(),
            'scrolltop': $cover.scrollTop(),
          });
          return false
        })
        .mousemove(function (event) {
          if ($cover.data('down')) {
            event.preventDefault();
            let move_x = $cover.data('x') - event.clientX;
            let move_y = $cover.data('y') - event.clientY;
            if (move_x !== 0 || move_y !== 0) {
              $cover.data('move', true);
              $cover.scrollLeft($cover.data('scrollleft') + move_x);
              $cover.scrollTop($cover.data('scrolltop') + move_y);
              return false
            }
          }
        })
        .mouseup(function (event) {
          $cover.data('down', false);

          // move後のlink無効
          if ($cover.data('move')) {
            return false;
          }
        });
    }

    // ドキュメント左上からの座標を取得
    function getOffset(el) {
      return {
        left: el.getBoundingClientRect().left + $cover.scrollLeft(),
        top: el.getBoundingClientRect().top + $cover.scrollTop(),
      };
    }

    // 間取りクリック時ズームイン
    const zoomIn = document.querySelectorAll('.js-zoomIn');
    zoomIn.forEach((elm) => {
      elm.addEventListener('click', (event) => {
        if (!$cover.data('move')) {
          event.preventDefault();
          let target = event.target;
          let targetId = target.getAttribute('aria-controls');
          zoomInFunc(target);
          history.pushState({}, '', '?zoom='+targetId);
        }
      });
    });

    let zoomInFunc = (elem) => {
      const parent = elem.parentNode;

      // 画面サイズによる係数
      let winScale = window.innerWidth / 1280;

      // 移動先の座標を求める
      let targetW = parent.getBoundingClientRect().width,
          targetH = parent.getBoundingClientRect().height,
          targetX = getOffset(parent).left,
          targetY = getOffset(parent).top,
          positionX = Number(elem.getAttribute('data-position-x')),
          positionY = Number(elem.getAttribute('data-position-y')),
          centerX = targetX + targetW * .5,
          centerY = targetY + targetH * .5,
          scale = Number(elem.getAttribute('data-scale')),
          name = elem.getAttribute('data-name'),
          scrollX, scrollY;
      if (window.innerWidth > 640) {
        scrollX = centerX - (positionX * winScale + targetW * scale * .5),
        scrollY = centerY - (positionY * winScale + targetH * scale * .5) - (window.innerHeight - 720 * winScale) * .5;
      } else {
        winScale = window.innerWidth / 750
        positionX = Number(elem.getAttribute('data-position-x-sp'));
        positionY = Number(elem.getAttribute('data-position-y-sp'));
        scale = Number(elem.getAttribute('data-scale-sp'));
        scrollX = centerX - (positionX * winScale + targetW * scale * .5),
        scrollY = centerY - (positionY * winScale + targetH * scale * .5);
      }
      console.log(scrollX, scrollY)

      // class操作
      document.body.classList.add('is-clicked');
      if ( name.match(/topic/) === null ) {
        parent.classList.add('is-selected');
      }

      // クリックされた要素までスクロール
      $cover.animate({
        scrollLeft: scrollX,
        scrollTop: scrollY,
      }, 500, 'swing')
      setTimeout(() => {
        // ズーム
        $coverZoom.css({
          'transform': 'scale('+scale+')',
          'transform-origin': centerX+'px '+centerY+'px'
        })
        // モーダル表示
        setTimeout(() => {
          const targetId = elem.getAttribute('aria-controls');
          const target = document.getElementById(targetId);
          // モーダルが非表示だった場合
          if (target.getAttribute('aria-hidden') === 'true') {
            elem.setAttribute('aria-expanded', 'true');
            target.setAttribute('aria-hidden', 'false');
            document.body.classList.add('is-zoomed');
          }
        }, 600);
      }, 300);
      return false;
    }

    // ズームアウト
    const zoomOut = document.querySelectorAll('.js-zoomOut');
    zoomOut.forEach((elm) => {
      elm.addEventListener('click', (event) => {
        event.preventDefault();
        let target = event.target;
        zoomOutFunc(target);
        history.pushState({}, '', window.location.pathname);
      });
    });

    let zoomOutFunc = (elem) => {
      // モーダル非表示
      let targetId = elem.getAttribute('aria-controls');
      let target = document.getElementById(targetId);

      if (target.getAttribute('aria-hidden') === 'false') {
        document.body.classList.remove('is-zoomed');
        elem.setAttribute('aria-expanded', 'false');
        target.setAttribute('aria-hidden', 'true');
      }

      setTimeout(() => {
        // ズームアウト
        $coverZoom.css({
          'transform': '',
        })
        // classリセット
        document.body.classList.remove('is-clicked');
        document.querySelectorAll('.js-figure').forEach(elem => {
          elem.classList.remove('is-selected');
        });
      }, 400);
      return false;
    }

    // ブラウザの戻る/進む操作を監視
    window.addEventListener('popstate', (event) => {
      let queryString = window.location.search;
      if (queryString) {
        // 表示中のモーダルを閉じる
        let zoomedSec = document.querySelector('.js-topSection[aria-hidden="false"]');
        console.log({zoomedSec})
        if (zoomedSec) {
          zoomedSec.setAttribute('aria-hidden', 'true');
          document.querySelectorAll('.js-figure').forEach(elem => {
            elem.classList.remove('is-selected');
          });
        }

        let params = new URLSearchParams(queryString);
        let zoom = params.get('zoom');
        let elem = document.querySelector('.js-zoomIn[aria-controls="'+zoom+'"]');
        if (elem) zoomInFunc(elem);
      } else {
        let elem = document.querySelector('.js-topSection[aria-hidden="false"] > .js-zoomOut');
        if (elem) zoomOutFunc(elem);
      }
    });


    // モーダル内スライド
    const thumbsOptions = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      loopAdditionalSlides: 1,
    };
    const NotesOptions = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      loopAdditionalSlides: 1,
    };
    const slideOptions = {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      loopAdditionalSlides: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };
    const interviewSlideOptions = Object.assign({}, slideOptions);
    const dtalkSlideOptions = Object.assign({}, slideOptions);

    const interviewSlideThumbs = new Swiper('.js-interviewSlideThumbs', thumbsOptions);
    const dtalkSlideThumbs = new Swiper('.js-dtalkSlideThumbs', thumbsOptions);

    const interviewSlideNotes = new Swiper('.js-interviewSlideNotes', NotesOptions);
    const dtalkSlideNotes = new Swiper('.js-dtalkSlideNotes', NotesOptions);

    interviewSlideOptions.thumbs = { swiper: interviewSlideThumbs };
    dtalkSlideOptions.thumbs = { swiper: dtalkSlideThumbs };

    interviewSlideOptions.controller = { control: interviewSlideNotes };
    dtalkSlideOptions.controller = { control: dtalkSlideNotes };

    const interviewSlide = new Swiper('.js-interviewSlide', interviewSlideOptions);
    const dtalkSlide = new Swiper('.js-dtalkSlide', dtalkSlideOptions);


    // 読み込み時のURLがクエリパラメータ付きの場合
    let firstUrl = new URL(window.location.href);
    let paramsZoom = firstUrl.searchParams.get('zoom');
    if ( paramsZoom ) {
      // オープニング画面をスキップ
      sessionStorage.setItem('first_visit', true);
      $('body').removeClass('is-opening');
      $('.js-opening').addClass('is-hidden');

      // 該当の間取り図までズーム
      document.querySelector('.js-figure.'+paramsZoom+' .js-zoomIn').click();

    } else {
      // 最初のスクロール位置を変更
      if ( window.innerWidth <= 640 ) {
        $cover.scrollLeft((130 * window.innerWidth / 375) / 2);
        $cover.scrollTop((613 * window.innerWidth / 375) / 2);
      }
      checkFirstVisit();
    }



    // オープニング画面
    var first_scroll = false;
    function unlock_splash() {
      first_scroll = true;
      setTimeout(function(){
        $('body').removeClass('is-opening');
        $('.js-opening').addClass('is-hidden');
      }, 500);
    }

    function checkFirstVisit() {
      if (sessionStorage.getItem('first_visit')) {
        // 再訪問時はオープニング画面をスキップ
        $('body').removeClass('is-opening');
        $('.js-opening').addClass('is-hidden');
      } else {
        // 初回訪問時のみオープニング画面を表示
        sessionStorage.setItem('first_visit', true);
        setTimeout(function(){
          $('#js-cover').on('scroll.first touchend.first', function () {
            if (!first_scroll) {
              unlock_splash();
            } else {
              $('#js-cover').off('scroll.first');
              $('#js-cover').off('touchend.first');
            }
          })
        }, 50);
      }
    }

    // メニューのMOVIE ROOMクリック時
    document.querySelector('.js-movieModalOpen').addEventListener('click', (event) => {
      document.querySelector('.l-header__toggle.close').click();
      document.querySelector('.js-figure.movie .js-zoomIn').click();
    });

  }
}

window.addEventListener("DOMContentLoaded", () => {
  if ( document.body.classList.contains('top') ) {
    new TopFunctions();
  }
});
